export default {
  "sideMenu.dashboard": "ダッシュボード",
  "sideMenu.film": "作品",
  "sideMenu.film.library": "作品一覧",
  "sideMenu.film.classification": "映倫管理",
  "sideMenu.film.moviTicketMaster": "ムビチケ（システム連携専用）券種マスター",
  "sideMenu.performance": "パフォーマンス",
  "sideMenu.performance.schedule": "スケジュール",
  "sideMenu.performance.priceRuleTemplate": "上映会テンプレート",
  "sideMenu.performance.discountRuleTemplate": "割引規則",
  "sideMenu.performance.version1": "スクリーン規格",
  "sideMenu.shop": "売店",
  "sideMenu.shop.concession": "コンセ",
  "sideMenu.shop.commercial": "物販",
  "sideMenu.shop.set": "セット",
  "sideMenu.shop.ingredient": "材料",
  "sideMenu.shop.othersGroupSetting": "その他仕入一覧",
  "sideMenu.shop.otherRevenue": "その他営業収入",
  "sideMenu.couponLib": "劇場優待券等",
  "sideMenu.couponLib.coupon": "劇場優待券 / 引換券",
  "sideMenu.couponLib.ticketVoucher": "劇場前売券 / 招待券",
  "sideMenu.operations": "オペレーション",
  "sideMenu.operations.nonArrivalTicketRecord": "未着券計上",
  "sideMenu.operations.cashierReport": "レジ確認",
  "sideMenu.operations.dailyClosing": "日次処理",
  "sideMenu.operations.monthlyClosing": "月次処理",
  "sideMenu.operations.accountsPayableManagement": "買掛金",
  "sideMenu.reports": "取引・レポート",
  "sideMenu.reports.businessDaily": "営業日報",
  "sideMenu.reports.occupancy": "各回充足率日報",
  "sideMenu.reports.box": "興行日報",
  "sideMenu.reports.filmRevenueWeekly": "成績週報",
  "sideMenu.reports.totalRevenue": "累計一覧",
  "sideMenu.reports.ticketTransaction": "取引履歴（チケット）",
  "sideMenu.reports.shopTransaction": "取引履歴（売店）",
  "sideMenu.reports.CLTransaction": "取引履歴（会費、ネット）",
  "sideMenu.reports.boxSaleReport": "興行成績表",
  "sideMenu.reports.boxSale": "劇場日報",
  "sideMenu.reports.pdfAccountReceivableBalanceDetail": "売掛残高明細",
  "sideMenu.reports.pdfFilmFee": "フィルム料一覧表",
  "sideMenu.reports.accountsReceivableVerify": "売掛金発生照合",
  "sideMenu.reports.otherTransaction": "取引履歴（その他営業収入）",
  "sideMenu.reports.transactionEditLog": "取引修正履歴",
  "sideMenu.reports.transactionLogTicket": "取引ログ（チケット）",
  "sideMenu.reports.transactionLogShop": "取引ログ（売店）",
  "sideMenu.reports.transactionLogOtherRevenue": "取引ログ (その他営業収入)",
  "sideMenu.reports.bookingDaily": "先行販売日報",
  "sideMenu.reports.arriveDaily": "当日着券日報",
  "sideMenu.reports.onlineBooking": "ネット予約（日 / 期間）",
  "sideMenu.reports.ticketSharing": "フィルム料",
  "sideMenu.reports.inventoryLog": "在庫調整ログ",
  "sideMenu.reports.inventory": "在庫一覧表（期間別）",
  "sideMenu.reports.revenueGoal": "売上目標管理",
  "sideMenu.reports.pdfFilmFeeBalance": "フィルム料残高一覧表",
  "sideMenu.reports.shopSale": "売店売上",
  "sideMenu.reports.cinemaDaily": "劇場日報",
  "sideMenu.reports.pdfAccountsReceivableBalance": "売掛金残高一覧表",
  "sideMenu.reports.ticketSales": "金券売上",
  "sideMenu.screen": "スクリーン",
  "sideMenu.settings": "設定",
  "sideMenu.settings.brandManagement": "ブランド管理",
  "sideMenu.settings.memberAgeGroup": "年齢区分",
  "sideMenu.settings.cinemaManagement": "劇場管理",
  "sideMenu.settings.global": "システムグローバル設定",
  "sideMenu.settings.payment": "支払方法",
  "sideMenu.settings.devices": "デバイス",
  "sideMenu.settings.devicesManagement": "デバイス管理",
  "sideMenu.settings.disableOnlineBooking": "ネット予約停止",
  "sideMenu.clientManagement": "クライアント管理",
  "sideMenu.clientManagement.deposit": "預金先管理",
  "sideMenu.clientManagement.client": "取引先管理",
  "sideMenu.clientManagement.clientGroup": "取引先区分管理",
  "sideMenu.users": "ユーザー",
  "sideMenu.users.userManagement": "アカウント",
  "sideMenu.users.roleManagement": "権限",
  "sideMenu.users.accountSetting": "ログイン設定",
  "sideMenu.accounting": "会計",
  "sideMenu.accounting.management": "勘定科目管理",
  "sideMenu.accountPayable.management": "買掛金管理",
  "sideMenu.accountReceivable.management": "売掛金管理",
  "sideMenu.help": "ヘルプ",
  "sideMenu.salesGroupManagement": "取引部門（帳票表示）管理",
  "sideMenu.accountingReportDownload": "会計仕訳/伝票",
  "sideMenu.reports.CLIkebukuro": "CL池袋専用帳票",
  "sideMenu.reports.accumulated": "成績累計",
  "sideMenu.reports.businessDailyDetail": "営業日報（詳細）",
  "sideMenu.notification": "お知らせ一覧",
  "sideMenu.businessDailyUpdate": "営業日報更新",
  "sideMenu.signage": "サイネージ",
  "sideMenu.cinemaSchedule": "スケジュールページ",
  "sideMenu.ticketCustomization": "チケットカスタマイズ",
  "sideMenu.customizedMessage": "カスタマイズ項目",
  "sideMenu.memberShip": "会員管理",
  "sideMenu.memberShip.list": "会員制度一覧",
  "sideMenu.memberList": "会員リスト",
  "sideMenu.automationRule": "自動化ルール",
  "sideMenu.onlineReservationSalesReport": "ネット予約売上",
};
